<nz-pagination
  [(nzPageIndex)]="index"
  [nzTotal]="total"
  [nzSize]="configuration.nzSize"
  [nzPageSize]="configuration?.nzPageSize"
  [nzDisabled]="configuration.nzDisabled"
  [nzShowQuickJumper]="configuration.nzShowQuickJumper"
  [nzSimple]="configuration.nzSimple"
  [nzResponsive]="configuration.nzResponsive"
  [nzPageSizeOptions]="configuration?.nzPageSizeOptions"
  [nzItemRender]="configuration.nzItemRender"
  [nzShowTotal]="configuration.nzShowTotal"
  (nzPageIndexChange)="onChange($event)"
></nz-pagination>
